<template>
  <section id="pricing-plan" class="pt-2">
    <!-- <div class="d-flex align-items-center mb-1">
      <h4 class="mr-1 mb-0">Monthly</h4>
      <b-form-checkbox
        id="priceSwitch"
        v-model="status"
        name="price-switch"
        value="annually"
        unchecked-value="monthly"
        switch
        class="custom-control-danger"
      />
      <h4 class="ml-50 mb-0">Annually</h4>
    </div> -->
    <b-row class="pricing-card">
      <b-col sm="12" md="12" lg="12">
        <b-row>
          <template v-if="loading">
            <b-col
              lg="4"
              md="6"
              cols="12"
              class="d-flex"
              v-for="index in 3"
              :key="index"
            >
              <b-card no-body class="w-100 p-1">
                <div
                  class="w-100 d-flex flex-column justify-content-center align-items-center"
                >
                  <b-skeleton width="30%" height="100px" />
                  <b-skeleton width="40%" height="30px" class="mx-1 mb-2" />
                  <b-skeleton width="40%" height="40px" class="mx-1 mb-2" />
                </div>
                <b-list-group class="list-group-circle text-left mx-2">
                  <b-list-group-item v-for="i in 5" :key="i" class="py-50">
                    <b-skeleton width="70%" height="20px" />
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-col>
          </template>
          <template v-else>
            <b-col
              lg="4"
              md="6"
              cols="12"
              class="d-flex"
              v-for="(plan, index) in plans"
              :key="index"
            >
              <b-card align="center" class="popular w-100">
                <div
                  class="d-flex flex-column align-items-center justify-content-center"
                >
                  <div
                    style="height: 200px; border: 1px solid #311d56"
                    class="rounded-lg w-100"
                    lg="12"
                  >
                    <b-img
                      style="max-height: 200px"
                      alt="basic svg img"
                      :src="
                        index == 0
                          ? require('@/assets/images/fxlegends/icon-01-subscriptionAsset 7.svg')
                          : index == 1
                          ? require('@/assets/images/fxlegends/icon-03-subscriptionAsset 9.svg')
                          : require('@/assets/images/fxlegends/icon-02-subscriptionAsset 8.svg')
                      "
                    />
                  </div>
                  <b-col
                    class="rounded-lg d-flex align-items-center p-1 justify-content-between"
                    lg="12"
                    style="
                      background-color: #262630;
                      width: 80%;
                      margin-top: -40px;
                      text-align: left;
                    "
                  >
                    <b-col class="px-50" lg="6">
                      <b-img
                        alt="basic svg img"
                        width="100"
                        :src="require('@/assets/images/fxlegends/logo2.png')"
                      />
                    </b-col>
                    <b-col class="px-50" lg="6">
                      <h3 class="font-weight-bolder my-0">
                        50 <span style="color: #fbad25">%</span>
                      </h3>
                      <h4 class="font-weight-bolder my-0">{{ plan.name }}</h4>
                      <!-- <small> A simple start for everyone </small> -->
                    </b-col>
                  </b-col>
                </div>

                <div class="annual-plan">
                  <div class="plan-price mt-2">
                    <span class="font-weight-bold" style="color: #f66395"
                      >$</span
                    >
                    <span
                      class="pricing-basic-value font-weight-bolder text-white"
                    >
                      {{ plan.fee }}
                    </span>
                    <sub
                      class="pricing-duration text-body font-medium-1 font-weight-bold"
                      >/month</sub
                    >
                  </div>
                </div>

                <b-list-group class="list-group-circle text-left mb-1">
                  <b-list-group-item
                    class="bottomBorder"
                    v-if="plan.first_month_competition"
                  >
                    {{ plan.first_month_competition }} free competitions first
                    month
                  </b-list-group-item>
                  <b-list-group-item
                    class="bottomBorder"
                    v-if="plan.monthly_competition"
                  >
                    {{ plan.monthly_competition }} competition each month
                  </b-list-group-item>
                  <b-list-group-item
                    class="bottomBorder"
                    v-if="plan.chart_update_duration"
                  >
                    Competition chart update every
                    {{ plan.chart_update_duration }} hours
                  </b-list-group-item>
                  <b-list-group-item
                    class="bottomBorder"
                    v-if="plan.competition_max_participant"
                  >
                    {{ plan.competition_max_participant }} participant per
                    competition (maximum)
                  </b-list-group-item>
                  <b-list-group-item
                    class="bottomBorder"
                    v-if="plan.competition_max_participant"
                  >
                    {{ plan.competition_max_participant }} participant per
                    competition (maximum)
                  </b-list-group-item>
                  <b-list-group-item class="bottomBorder" v-if="plan.min_award">
                    {{ plan.min_award }}$ maximum prize pool per competition
                  </b-list-group-item>
                  <b-list-group-item
                    class=" "
                    v-if="plan.advance_user_analytics"
                  >
                    Advanced user data and analytics
                  </b-list-group-item>
                </b-list-group>
                <div>
                  <!-- <b-button
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="outline-light rounded-pill font-weight-bolder"
                    size="lg"
                  >
                    Current Plan
                  </b-button> -->
                  <b-button
                    class="w-100"
                    v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                    variant="info rounded-pill font-weight-bolder"
                    size="lg"
                    @click="showBuyModal(plan)"
                  >
                    <feather-icon icon="BookmarkIcon" size="22" />
                    Buy
                  </b-button>
                </div>
              </b-card>
            </b-col>
          </template>
        </b-row>
      </b-col>
    </b-row>
    <buy-plan-modal
      :visible="visibleBuyPlanModal"
      v-model="visibleBuyPlanModal"
      :plan="planSelected"
    />
  </section>
</template>

<script>
import {
  BFormCheckbox,
  BRow,
  BCol,
  BCard,
  BImg,
  BCardText,
  BListGroup,
  BListGroupItem,
  BButton,
  BBadge,
  BSkeleton,
} from "bootstrap-vue";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import Ripple from "vue-ripple-directive";
import BuyPlanModal from "../step3/BuyPlanModal.vue";

/* eslint-disable global-require */
export default {
  components: {
    BuyPlanModal,
    BFormCheckbox,
    BButton,
    BCardText,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    BCard,
    BBadge,
    BImg,
    AppCollapseItem,
    AppCollapse,
    BSkeleton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      // status: "monthly",
      // monthlyPlanShow: true,
      planSelected: {},
      visibleBuyPlanModal: false,

      loading: false,
      meetup: {
        mediaData: [
          {
            avatar: "CalendarIcon",
            title: "Sat, May 25, 2020",
            subtitle: "10:AM to 6:PM",
          },
          {
            avatar: "MapPinIcon",
            title: "Central Park",
            subtitle: "Manhattan, New york City",
          },
        ], 
      },
    };
  },
  async created() {
    this.loading = true;
    await this.getPlans();
    this.loading = false;
  },
  //  require('@/assets/images/fxlegends/icon-03-subscriptionAsset 9.svg')
  // require('@/assets/images/fxlegends/icon-02-subscriptionAsset 8.svg')
  methods: {
    showBuyModal(plan) {
      this.visibleBuyPlanModal = true;
      this.planSelected = plan;
    },
    async getPlans() {
      try {
        const { data } = await this.$http.get("/panel/plans");
        this.plans = data.data;
      } catch (err) {}
    },
    // tooglePlan() {
    //   if (this.status === "monthly") {
    //     this.monthlyPlanShow = true;
    //   } else {
    //     this.monthlyPlanShow = false;
    //   }
    // },
  },
};
/* eslint-disable global-require */
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-pricing.scss";
.bottomBorder {
  border-bottom: 1px dashed rgba(112, 112, 112, 0.27) !important;
  border-radius: 0;
}
</style>
